var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.handleDialog(true)}}},[_c('iconify-icon',{staticClass:"iconify",attrs:{"data-icon":"mdi:share-variant"}}),_c('share-dialog',{attrs:{"value":_vm.open},on:{"input":_vm.handleDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }